/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .mat-expansion-panel{margin:6px}[_nghost-%COMP%]   .domain-logo[_ngcontent-%COMP%]     img{max-height:200px}@media (max-width:959px){.domain-info[_ngcontent-%COMP%]{margin-bottom:50px}[_nghost-%COMP%]     .info-value{max-width:120px!important;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}}.material-icons[_ngcontent-%COMP%]{color:#000}.material-icons[_ngcontent-%COMP%]:hover{text-decoration:none!important}"];
export { styles as styles };
